import axios from "axios";
import { ENDPOINT } from "../ENDPOINT";

export const EmailConfigService = {
  get: async () => {
    const res = await axios.get(ENDPOINT.EmailConfig);
    return res.data;
  },
  save: async (data) => {
    const res = await axios.post(ENDPOINT.EmailConfig, data);
    return res.data;
  },
  sendReminder: async (data) => {
    const res = await axios.post(`${ENDPOINT.EmailConfig}/send-reminder`, data);
    return res.data;
  },
};